import * as ActionTypes from '../components/actions/types';

function projectReducer(
  state = {
    selected: 'all',
    projects: [],
    submissionCardProject: { isFetching: true },
    currentProject: { isFetching: true, pyamentStatus: '' }
  },
  action,
) {
  switch (action.type) {
    case ActionTypes.PROJECT_RESET_SINGLE_FOR_SUBMISSION_CARD:
      return {
        ...state,
        submissionCardProject: action.payload
      };
    case ActionTypes.PROJECT_FETCH_SINGLE_FOR_SUBMISSION_CARD:
      return {
        ...state,
        submissionCardProject: { isFetching: false, ...action.payload }
      };
    case ActionTypes.PROJECT_FETCH_SINGLE:
      return {
        ...state,
        currentProject: { isFetching: false, ...action.payload }
      };
    case ActionTypes.PROJECT_UPDATE_SINGLE:
      return {
        ...state,
        currentProject: { ...state.currentProject, ...action.payload }
      };
    case ActionTypes.PROJECT_RESET_SINGLE:
      return {
        ...state,
        currentProject: action.payload
      };
    case ActionTypes.PROJECT_FETCH_ALL:
      return {
        ...state,
        projects: action.payload
      };
    case ActionTypes.APPLY_PROJECT:
      return {
        ...state,
        projects: state.projects.map(
          project =>
            (project.id === action.payload.id
              ? { ...project, isCollaborator: true }
              : project),
        )
      };
    case ActionTypes.LEAVE_PROJECT:
      return {
        ...state,
        projects: state.projects.map(
          project =>
            (project.id === action.payload.id
              ? { ...project, isCollaborator: false }
              : project),
        )
      };
    case ActionTypes.PROJECT_SWTICH_VIEW:
      return {
        ...state,
        selected: action.payload
      };
    case ActionTypes.PROJECT_UDPATE:
      return {
        ...state
      };
    case ActionTypes.POST_PROJECT_BRIEF:
      return {
        ...state
      };
    default: {
      return state;
    }
  }
}

export default projectReducer;



// WEBPACK FOOTER //
// ./src/reducers/project.js